import { render } from "./StepStrictly.vue?vue&type=template&id=c8c92900"
import script from "./StepStrictly.vue?vue&type=script&lang=ts"
export * from "./StepStrictly.vue?vue&type=script&lang=ts"
script.render = render

export default script